import { render, staticRenderFns } from "./BlackHeader.vue?vue&type=template&id=083d6118&scoped=true&"
import script from "./BlackHeader.vue?vue&type=script&lang=js&"
export * from "./BlackHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlackHeader.vue?vue&type=style&index=0&id=083d6118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d6118",
  null
  
)

export default component.exports